import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Button({ value }) {
  return (
    <button
      type="submit"
      className="mt-6 transition transition-all block py-3 px-4 w-full text-white font-bold rounded cursor-pointer bg-gradient-to-r from-indigo-600 to-purple-400 hover:from-indigo-700 hover:to-purple-500 focus:bg-indigo-900 transform hover:-translate-y-1 hover:shadow-lg"
    >
      {value}
    </button>
  );
}

function Input({ type, id, name, label, placeholder, autofocus, value, onChange, error }) {
  return (
    <label className="text-gray-500 block mt-3">
      {label}
      <input
        autoFocus={autofocus}
        type={type}
        id={id}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`rounded px-4 py-3 w-full mt-1 bg-white text-gray-900 border ${
          error ? "border-red-500" : "border-gray-200"
        } focus:border-indigo-400 focus:outline-none focus:ring focus:ring-indigo-100`}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </label>
  );
}

function AdminLogIn() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ username: "", password: "" });
  const navigate = useNavigate();

  // Sample credentials
  const VALID_USERNAME = "admin";
  const VALID_PASSWORD = "Admin123!";

  const validateCredentials = (username, password) => {
    return username === VALID_USERNAME && password === VALID_PASSWORD;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = { username: "", password: "" };
    
    if (!username) {
      newErrors.username = "Username is required.";
    }

    if (!password) {
      newErrors.password = "Password is required.";
    }

    setErrors(newErrors);

    if (!newErrors.username && !newErrors.password) {
      try {
        const response = await axios.post('/api/admin/login', { username, password });
        console.log(response.data.message);
        sessionStorage.setItem("isAuthenticated", "true");
        navigate('/dashboard');  // Redirect to dashboard on success
      } catch (error) {
        console.error(error);
      
      // Handle Axios error and set error state
      if (error.response) {
        // Response exists, meaning it's a 400 error with a message
        setErrors({ password: error.response.data.message });  // Show message in the error field
      } else {
        // Network or other issues
        setErrors({ password: 'Something went wrong. Please try again later.' });
      }
      }
    }
  };

  return (
    <div className="bg-customBlue flex justify-center items-center h-screen w-screen">
      <div className="border-t-8 rounded-sm border-indigo-600 bg-white p-12 shadow-2xl w-96">
        <h1 className="font-bold text-center block text-2xl">Log In</h1>
        <form onSubmit={handleSubmit}>
          <Input
            type="text"
            id="username"
            name="username"
            label="Username"
            placeholder="Enter your username"
            autofocus={true}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            error={errors.username}
          />
          <Input
            type="password"
            id="password"
            name="password"
            label="Password"
            placeholder="••••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={errors.password}
          />
          <Button value="Submit" />
        </form>
      </div>
    </div>
  );
}

export default AdminLogIn;